import { ProfileDetailsVibeBondingPace } from './bondingPace';
import {
  ProfileDetailsVibeCommsVibe,
  type ProfileDetailsVibeCommsVibeProps,
} from './commsVibe';
import {
  ProfileDetailsVibeDuoPersonality,
  type ProfileDetailsVibeDuoPersonalityProps,
} from './duoPersonality';
import {
  ProfileDetailsVibeHeader,
  type ProfileDetailsVibeHeaderProps,
} from './header';
import {
  ProfileDetailsVibePlayTime,
  type ProfileDetailsVibePlayTimeProps,
} from './playTime';
import {
  ProfileDetailsVibePreGameRitual,
  type ProfileDetailsVibePreGameRitualProps,
} from './preGameRitual';
import {
  ProfileDetailsVibeQueueStylePreference,
  type ProfileDetailsVibeQueueStylePreferenceProps,
} from './queueStylePreference';
import {
  ProfileDetailsVibeRoot,
  type ProfileDetailsVibeRootProps,
} from './vibeRoot';
import { ProfileDetailsVibeVoiceChatParticipation } from './voiceChat';

export const ProfileDetailsVibe = {
  Root: ProfileDetailsVibeRoot,
  Header: ProfileDetailsVibeHeader,
  DuoPersonality: ProfileDetailsVibeDuoPersonality,
  QueueStylePreference: ProfileDetailsVibeQueueStylePreference,
  PreGameRitual: ProfileDetailsVibePreGameRitual,
  CommsVibe: ProfileDetailsVibeCommsVibe,
  BondingPace: ProfileDetailsVibeBondingPace,
  VoiceChatParticipation: ProfileDetailsVibeVoiceChatParticipation,
  PlayTime: ProfileDetailsVibePlayTime,
} as const;

export type {
  ProfileDetailsVibeCommsVibeProps,
  ProfileDetailsVibeDuoPersonalityProps,
  ProfileDetailsVibeHeaderProps,
  ProfileDetailsVibePlayTimeProps,
  ProfileDetailsVibePreGameRitualProps,
  ProfileDetailsVibeQueueStylePreferenceProps,
  ProfileDetailsVibeRootProps,
};
